/**
 * Created by ganlu on 30/12/2016.
 */
class GetReproductionService {
    constructor(message,$filter) {
        "ngInject";

        this.message = message;
        this.tranlsteFilter=$filter('translate');

    }

    get() {
        this.message.error(this.tranlsteFilter('page-original-text125'));
    }
}

export default GetReproductionService;



// WEBPACK FOOTER //
// ./src/app/components/page/original/get-reproduction/get-reproduction.service.js